module.exports = __webpack_public_path__ + "media/images/img_top_explain02-d9817430ed52a2a5ee0e2bd1c921fbbb.jpg";